<template>
  <div class="position-relative">
    <CButton variant="ghost" color="primary" class="btn-notification" size="sm" v-show="hasNotifications"
             @click.stop="toggleNotifier">
      <translate>Summary</translate>&nbsp;<span v-if="notificationNum > 0">({{ notificationNum }})</span>
      <CIcon name="cipChevronLeft" size="lg" :style="{'transform': show ? 'rotate(90deg)' : 'rotate(270deg)'}"/>
    </CButton>

      <div class="uploader__notifications" v-if="show && hasNotifications">
        <div class="modal-header">
          <h5 class="modal-title" v-translate translate-context="uploader">Notifications</h5>
          <CButtonClose class="close-panel" @click.stop="toggleNotifier">
            <CIcon name="cipChevronLeft" size="lg" style="transform: rotate(270deg)"/>
          </CButtonClose>
        </div>
        <CRow>
          <CCol sm="12">
            <div class="d-flex align-items-center justify-content-between p-3">
              <PTabs :tabs="tabs" :selected="tab" @select="tab = $event" pills/>

              <CLink @click.stop="clearNotifications" class="clear-notification" v-translate translate-context="uploader"
                     :disabled="notificationTabIsEmpty">Clear Notifications
              </CLink>
            </div>

          </CCol>
          <CCol sm="12">
            <CAlert color="primary" class="alert-uploader alert-uploader--info mx-3" :fade="false"
                    v-if="tab === tabs.COMPLETED.name && canSeePhotoSearch">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <translate>View your file in the "Browse Photo" section</translate>
                </div>
                <CButton :to="{name: 'photoSearch.search', params: {picaServiceId: $route.params.picaServiceId}}"
                         color="primary" variant="outline" v-translate translate-context="uploader">View
                </CButton>
              </div>
            </CAlert>
            <NotificationTable
                :rows="completed"
                v-show="tab === tabs.COMPLETED.name"
                @loadI@loadImage="$emit('loadImage',$event)"
                @delete="$emit('delete-completed',$event)"
            />
            <NotificationTable
                :rows="failedAndPending"
                v-show="tab === tabs.FAILED.name"
                @loadImage="$emit('loadImage',$event)"
                @delete="onDeleteFailed"
                failed
            />
          </CCol>
        </CRow>

      </div>

  </div>

</template>

<script>
import NotificationTable from "@/domain/uploader/components/NotificationTable.vue";
import PTabs from "@/domain/core/components/PTabs.vue";

export default {
  name: "Notifications",
  components: {PTabs, NotificationTable},
  props: {
    completed: {
      type: Array,
      required: true
    },
    pending: {
      type: Array,
      required: true
    },
    failed: {
      type: Array,
      required: true
    },
    canSeePhotoSearch: {
      type: Boolean,
      required: true

    },
  },
  data() {
    return {
      show: false,
      tab: 'completed',
    }
  },
  computed: {
    hasNotifications() {
     return  this.notificationNum > 0
    },
    failedAndPending() {
      let pending = this.pending.map(file => {
        return {
          ...file,
          retry: true,
          pending: true,
          motivation: 'File pending'
        }
      })
      return [
        ...pending,
        ...this.failed
      ]
    },
    notificationNum() {
      return this.completed.length + this.failed.length + this.pending.length
    },
    notificationTabIsEmpty() {
      if (this.tab === this.tabs.COMPLETED.name)
        return this.completed.length <= 0
      else if (this.tab === this.tabs.FAILED.name)
        return this.failed.length <= 0 && this.pending.length <= 0
      return true
    },
    tabs() {
      return {
        COMPLETED: {
          name: 'COMPLETED',
          label: this.generateLabel('Completed', this.completed.length),
        },
        FAILED: {
          name: 'FAILED',
          label: this.generateLabel('Failed', this.failed.length + this.pending.length),
        },
      }
    },
  },
  emits: ['delete-failed', 'delete-completed', 'delete-pending', 'loadImage'],
  methods: {
    toggleNotifier() {
      if (this.completed.length > 0)
        this.toggle(this.tabs.COMPLETED.name)
      else if (this.failed.length > 0 || this.pending.length > 0)
        this.toggle(this.tabs.FAILED.name)
    },
    toggle(tab) {
      this.show = !this.show
      this.tab = tab
    },
    clearNotifications() {
      if (this.tab === this.tabs.COMPLETED.name)
        this.$emit('delete-completed', this.completed)
      else if (this.tab === this.tabs.FAILED.name) {
        this.$emit('delete-failed', this.failed)
        this.$emit('delete-pending', this.pending)
      }
      this.show = false
    },
    generateLabel(tab, num) {
      let label = this.$pgettext('uploader', tab)
      if (num > 0)
        label += ' (' + num + ')'
      return label
    },
    onDeleteFailed(files) {
      const pending = files.filter(file => file.pending)
      const failed = files.filter(file => !file.pending)
      if (pending.length > 0)
        this.$emit('delete-pending', pending)
      if (failed.length > 0)
        this.$emit('delete-failed', failed)
    }
  }
}
</script>

<style scoped>

</style>